module.exports = __webpack_public_path__ + "img/square-user.3d116c1c.svg";